/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  // Input,
  Modal,
  TreeSelect,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { checkToken } from 'api/utils';
import { NOMBRES_PATTERN } from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import {
  CRUDclavePresupuestalEgresos,
  mapWithKeys,
  ModelClavesPresupuestalesDeEgreso,
} from 'api/configuraciones/clavesPresupuestalesDeEgresos';
import Input from 'antd/lib/input/Input';
import { useSelector } from 'react-redux';
import {
  findInTree,
  formatTreeSelectData, normalizeCuentasContables,
  normalizeDataAreas,
} from 'api/configuraciones/clavesPresupuestalesDeIngresos';
import { seelectEntidad } from 'store/auth';
import { getSegmentosDeConfiguracion, segmentoAplica } from 'utils/segmentosPresupuestales';
import ClavePresupuestalEgresosConceptosDeEgreso from './ClavePresupuestalEgresosConceptosDeEgreso';

export const clavesPresupuestalesDeEgresosPermission = {
  permissionModel: 'clavepresupuestalegreso',
  catalogsModels: [],
  tabsModels: [],
};

const ClavesPresupuestalesDeEgresos = (
  {
    permission, defaultValues,
    configurador, setReload,
  },
) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);

  const [periodoFiscal, setPeriodoFiscal] = useState([]);
  const entidad = useSelector(seelectEntidad);
  const [areas, setAreas] = useState([]);
  const [destinosPresupuestales, setDestinosPresupuestales] = useState([]);
  const [funcionesPresupuestales, setFuncionesPresupuestales] = useState([]);
  const [programas, setProgramas] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [clasificacionesAdministrativas, setClasificacionesAdministrativas] = useState();
  const [clasificacionesFuncionales, setClasificacionesFuncionales] = useState();
  const [clasificacionesProgramaticas, setClasificacionesProgramaticas] = useState();
  const [tiposDeGasto, setTiposDeGasto] = useState();
  const [fuentesFinanciamiento, setFuentesFinanciamiento] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [catalogoCuentasContables, setCatalogoCuentasContables] = useState();
  const [planDeCuentas, setPlanDeCuentas] = useState();
  // const [cogs, setCogs] = useState([]);
  const [estados, setEstados] = useState([]);
  // undefined = cargando; null = sin configuración de segmentos (se muestran todos los campos)
  const [segmentos, setSegmentos] = useState(undefined);

  const registroName = '';
  const cliente = CRUDclavePresupuestalEgresos;
  const {
    nameModel,
    nameModelSingular,
  } = ModelClavesPresupuestalesDeEgreso;

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await cliente.obtenerListaDeRegistros();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const {
        _ejercicioFiscal,
        _areas,
        _destinosPresupuestales,
        _programas,
        _proyectos,
        _funcionesPresupuestales,
        _clasificacionAdministrativa,
        _clasificacionFuncional,
        _clasificacionProgramatica,
        // _cogs,
        _tiposDeGastos,
        _fuentesFinanciamientos,
        _tipoDeNominaEmpleado,
        _planDeCuentas,
        _catalogoCuentasContables,
        _estados,
      } = defaultValues;
      const _data = await cliente.obtenerListaDeRegistros();
      setPeriodoFiscal(_ejercicioFiscal);
      const formattedURS = formatTreeSelectData(normalizeDataAreas(_areas));
      setAreas(formattedURS);
      setDestinosPresupuestales(_destinosPresupuestales);
      setProgramas(_programas);
      setProyectos(_proyectos);
      setFuncionesPresupuestales(_funcionesPresupuestales);
      setClasificacionesAdministrativas(mapWithKeys(_clasificacionAdministrativa));
      setClasificacionesFuncionales(mapWithKeys(_clasificacionFuncional));
      setClasificacionesProgramaticas(mapWithKeys(_clasificacionProgramatica));
      // setCogs(_cogs);
      setTiposDeGasto(_tiposDeGastos);

      setFuentesFinanciamiento(_fuentesFinanciamientos);

      setTiposNominasEmpleados(_tipoDeNominaEmpleado);
      const normalizedCuentas = normalizeCuentasContables(
        _catalogoCuentasContables,
      );
      const normalizedPlanCuentas = normalizeCuentasContables(
        _planDeCuentas,
      );
      setPlanDeCuentas(normalizedPlanCuentas);
      setCatalogoCuentasContables(normalizedCuentas);
      setEstados(_estados);
      setSegmentos(await getSegmentosDeConfiguracion(configurador?.id));
      setData(formatReceived(_data));
      setLoading(false);
    };
    if (!defaultValues
      || typeof defaultValues !== 'object'
      || Object.keys(defaultValues).length === 0) {
      return;
    }
    fetchAll();
  }, [defaultValues, configurador?.id]);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _nivelDeEstudio = await cliente.obtenerUnRegistro(match.id);
    setTimeout(() => {
      if (_nivelDeEstudio) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_nivelDeEstudio));
          setDisableFields(_nivelDeEstudio?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? cliente.actualizarRegistro(key, values) : cliente.crearRegistro(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await cliente.borrarRegistro(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  // const handleKeyPress = (e) => {
  //   if (/\d/.test(e.key)) {
  //     e.preventDefault();
  //   }
  // };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Nivel de Estudios ya autorizado');
        return;
      }
      const saved = await await cliente.autorizarRegistro(key);
      if (saved) {
        await fetchData();
        setReload((prev) => !prev);
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const aplica = (campo) => segmentoAplica(segmentos, campo);

  const allColumns = [
    {
      titleText: 'Ejercicio',
      dataIndex: 'periodo_fiscal',
      key: 'periodo_fiscal',
      width: 150,
      render: (val) => (periodoFiscal?.find((e) => e.id === val)?.periodo),
    },
    {
      titleText: 'Identificador Geográfico',
      dataIndex: 'identificador_geografico',
      key: 'identificador_geografico',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area',
      key: 'directorio_de_area',
      width: 150,
      render: (val) => {
        const found = findInTree(areas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Destino Presupuestal',
      dataIndex: 'destino_presupuestal',
      key: 'destino_presupuestal',
      width: 200,
      render: (val) => (destinosPresupuestales?.find((e) => e.id === val)?.nombre),
    },
    {
      titleText: 'Programa',
      dataIndex: 'programa',
      key: 'programa',
      width: 200,
      render: (val) => {
        const item = programas?.find((e) => e.id === val);
        return (item ? `${item.clave} - ${item.descripcion}` : '');
      },
    },
    {
      titleText: 'Proyecto',
      dataIndex: 'proyecto',
      key: 'proyecto',
      width: 200,
      render: (val) => {
        const item = proyectos?.find((e) => e.id === val);
        return (item ? `${item.clave} - ${item.descripcion}` : '');
      },
    },
    {
      titleText: 'Función Presupuestal',
      dataIndex: 'funcion_presupuestal',
      key: 'funcion_presupuestal',
      width: 200,
      render: (val) => {
        const item = funcionesPresupuestales?.find((e) => e.id === val);
        return (item ? `${item.numero} - ${item.nombre}` : '');
      },
    },
    {
      titleText: 'Clasificación Administrativa',
      dataIndex: 'clasificacion_administrativa',
      key: 'clasificacion_administrativa',
      width: 250,
      render: (val) => {
        const found = findInTree(clasificacionesAdministrativas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Clasificación Funcional',
      dataIndex: 'clasificacion_funcional',
      key: 'clasificacion_funcional',
      width: 250,
      render: (val) => {
        const found = findInTree(clasificacionesFuncionales, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Clasificación Programática',
      dataIndex: 'clasificacion_programatica',
      key: 'clasificacion_programatica',
      width: 300,
      render: (val) => {
        const found = findInTree(clasificacionesProgramaticas, val);
        return found ? found.title : val;
      },
    },
    // {
    //   titleText: 'Clasificador por Objeto del Gasto',
    //   dataIndex: 'clasificador_de_objeto_de_gasto',
    //   key: 'clasificador_de_objeto_de_gasto',
    //   render: (val) => {
    //     const found = findInTree(cogs, val);
    //     return found ? found.title : val;
    //   },
    //   width: 300,
    // },
    {
      titleText: 'Fuente de Financiamiento',
      dataIndex: 'fuente_financiamiento',
      key: 'fuente_financiamiento',
      width: 260,
      render: (val) => {
        const fuente = fuentesFinanciamiento?.find((e) => e.id === val);
        return fuente ? `${fuente.clave} - ${fuente.nombre}` : val;
      },
    },
    {
      titleText: 'Tipo de Gasto',
      dataIndex: 'tipo_de_gasto',
      key: 'tipo_de_gasto',
      width: 200,
      render: (val) => (tiposDeGasto?.find((e) => e.id === val)?.nombre),
    },
    {
      titleText: 'Tipo de Nómina-Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (val) => {
        const _tipoNominaEmpleado = tiposNominasEmpleados.find((e) => e.id === val);
        return _tipoNominaEmpleado?.descripcion;
      },
    },
    {
      titleText: 'Plan de Cuentas',
      dataIndex: 'cuenta_contable_conac',
      key: 'cuenta_contable_conac',
      width: 250,
      render: (val) => {
        const found = findInTree(planDeCuentas, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 250,
      render: (val) => {
        const found = findInTree(catalogoCuentasContables, val);
        return found ? found.title : val;
      },
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => (estados?.find((e) => e.id === val)?.descripcion),
    },
  ];

  const columns = allColumns.filter((col) => aplica(col.dataIndex));

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'clavepresupuestalegreso', action: 'autorizar' },
              icon: <CheckCircleOutlined />,
              text: 'Autorizar',
              disabledBySelection: true,
              disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
              className: 'success',
            },
          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          width="90%"
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} ${nameModel}`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableFields}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="periodo_fiscal"
                  rules={[{ required: true, message: 'Se Requiere Ejercicio Fiscal' }]}
                  label="Ejercicio"
                  hasFeedback
                >
                  <Select
                    labelProp="periodo"
                    allowClear
                    disabled={disableFields}
                    dataSource={periodoFiscal}
                  />
                </Form.Item>
              </Col>

              {aplica('identificador_geografico') ? (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="identificador_geografico"
                    rules={[{ required: true, message: 'Seleccione el Identificador Geográfico' }]}
                    label="Identificador Geográfico"
                    hasFeedback
                    initialValue={
                      entidad?.identificador_geografico ?? 0
                    }
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              ) : (
                // No forma parte de la clave, pero se sigue guardando el dato de la entidad
                <Form.Item
                  name="identificador_geografico"
                  hidden
                  initialValue={entidad?.identificador_geografico ?? 0}
                >
                  <Input />
                </Form.Item>
              )}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="configuracion_presupuestal"
                  label="Segmento Presupuestal"
                  hasFeedback
                  initialValue={configurador?.id}
                >
                  {/* Guarda el id de la configuración y muestra su identificador */}
                  <Select
                    disabled
                    dataSource={configurador?.id ? [configurador] : []}
                    labelProp="identificador"
                  />
                </Form.Item>
              </Col>
              {aplica('directorio_de_area') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="directorio_de_area"
                    label="Área"
                    rules={rules.required}
                    hasFeedback
                  >
                    <TreeSelect
                      showSearch
                      treeNodeFilterProp="title"
                      treeData={areas}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}

              {aplica('destino_presupuestal') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="destino_presupuestal"
                    label="Destino Presupuestal"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={destinosPresupuestales}
                      disabled={disableFields}
                      keyProp="id"
                      labelProp="nombre"
                      render={(item) => `${item.numero || ''} - ${item.nombre}`}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              )}

              {aplica('programa') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="programa"
                    rules={[{ required: true, message: 'Seleccione el Programa' }]}
                    label="Programa"
                    hasFeedback
                  >
                    <Select
                      keyLabelRender
                      render={(item) => (item ? `${item.clave} - ${item.descripcion}` : '')}
                      dataSource={programas}
                      allowClear
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}

              {aplica('proyecto') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="proyecto"
                    rules={[{ required: true, message: 'Seleccione el Proyecto' }]}
                    label="Proyecto"
                    hasFeedback
                  >
                    <Select
                      keyLabelRender
                      // labelProp="nombre"
                      render={(item) => (item ? `${item.clave} - ${item.descripcion}` : '')}
                      dataSource={proyectos}
                      allowClear
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}
              {aplica('funcion_presupuestal') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="funcion_presupuestal"
                    label="Función Presupuestal"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={funcionesPresupuestales}
                      disabled={disableFields}
                      keyProp="id"
                      labelProp="nombre"
                      render={(item) => `${item.numero || ''} - ${item.nombre}`}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              )}
              {/* <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="directorio_de_area"
                  label="Área"
                  rules={rules.required}
                  hasFeedback
                >
                  <TreeSelect
                    showSearch
                    treeNodeFilterProp="title"
                    treeData={areas}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="cri"
                  rules={[{ required: true, message: 'Seleccione la Clasificación Funcional' }]}
                  label="Clasificador por Rubro de Ingresos"
                  hasFeedback
                >
                  <TreeSelect
                    showSearch
                    key="key"
                    treeData={clases}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col> */}
              {aplica('clasificacion_administrativa') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clasificacion_administrativa"
                    rules={[{ required: true, message: 'Seleccione la Clasificación Administrativa' }]}
                    label="Clasificación Administrativa"
                    hasFeedback
                  >
                    <TreeSelect
                      showSearch
                      treeNodeFilterProp="title"
                      treeData={clasificacionesAdministrativas}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}
              {aplica('clasificacion_funcional') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clasificacion_funcional"
                    rules={[{ required: true, message: 'Seleccione la Clasificación Funcional' }]}
                    label="Clasificación Funcional"
                    hasFeedback
                  >
                    <TreeSelect
                      showSearch
                      treeNodeFilterProp="title"
                      treeData={clasificacionesFuncionales}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}
              {aplica('clasificacion_programatica') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clasificacion_programatica"
                    rules={[{ required: true, message: 'Seleccione la Clasificación Programatica' }]}
                    label="Clasificación Programatica"
                    hasFeedback
                  >
                    <TreeSelect
                      showSearch
                      treeNodeFilterProp="title"
                      treeData={clasificacionesProgramaticas}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}
              {aplica('tipo_de_gasto') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_gasto"
                    rules={[{ required: true, message: 'Seleccione el Tipo de Gasto' }]}
                    label="Tipo de Gasto"
                    hasFeedback
                  >
                    <Select
                      labelProp="nombre"
                      allowClear
                      disabled={disableFields}
                      dataSource={tiposDeGasto}
                    />
                  </Form.Item>
                </Col>
              )}
              {aplica('fuente_financiamiento') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fuente_financiamiento"
                    label="Fuente de Financiamiento"
                    rules={[{ required: true, message: 'Seleccione una fuente de financiamiento' }]}
                  >
                    <Select
                      render={(value) => `${value?.clave} - ${value?.nombre}`}
                      allowClear
                      disabled={disableFields}
                      dataSource={fuentesFinanciamiento}
                    />
                  </Form.Item>
                </Col>
              )}
              {aplica('tipo_de_nomina_empleado') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Tipo de Nómina Empleado"
                    name="tipo_de_nomina_empleado"
                    rules={[{ required: true, message: 'Seleccione un Tipo de Nomina Empleado' }]}
                  >
                    <Select
                      keyProp="id"
                      labelProp="descripcion"
                      dataSource={tiposNominasEmpleados}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}
              {aplica('cuenta_contable_conac') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="cuenta_contable_conac"
                    rules={[{ required: true, message: 'Seleccione el Plan de Cuentas' }]}
                    label="Plan de cuentas"
                    hasFeedback
                  >
                    <TreeSelect
                      showSearch
                      treeNodeFilterProp="title"
                      treeData={planDeCuentas}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}
              {aplica('cuenta_contable') && (
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="cuenta_contable"
                    rules={[{ required: true, message: 'Seleccione la Cuenta Contable' }]}
                    label="Cuenta Contable"
                    hasFeedback
                  >
                    <TreeSelect
                      showSearch
                      treeNodeFilterProp="title"
                      treeData={catalogoCuentasContables}
                      disabled={disableFields}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Row>
          </Form>
          {!!selectedRowKeys.length && (
            <ClavePresupuestalEgresosConceptosDeEgreso
              permission={permission}
              fatherID={selectedRowKeys}
              disableFieldsParent={disableFields}
            />
          )}
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`${nameModelSingular} ${registroName}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`Autorizar ${nameModelSingular} ${registroName}`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          contentTitle={`Inactivar ${nameModelSingular} ${registroName}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ClavesPresupuestalesDeEgresos;
